//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    },
    template: {
      type: String,
      "default": null
    },
    fullHeight: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    outerStyle: function outerStyle() {
      if (this.fullHeight) {
        return {
          height: "100%"
        };
      }

      return {};
    },
    innerStyle: function innerStyle() {
      var style = {
        padding: "0"
      };

      if (this.fullHeight) {
        return Object.assign(style, {
          height: "100%"
        });
      }

      return style;
    }
  }
};